// These definitions come from TCGPlayer: /catalog/categories/3/printings
export const printingIds = {
  10: {
    name: "Normal",
    displayOrder: 1,
    modifiedOn: "2013-04-03T11:43:38.8",
  },
  11: {
    name: "Holofoil",
    displayOrder: 2,
    modifiedOn: "2013-04-03T11:43:38.8",
  },
  77: {
    name: "Reverse Holofoil",
    displayOrder: 3,
    modifiedOn: "2017-12-20T11:04:27.92",
  },
  78: {
    name: "1st Edition Normal",
    displayOrder: 4,
    modifiedOn: "2017-12-20T11:04:27.92",
  },
  79: {
    name: "1st Edition Holofoil",
    displayOrder: 5,
    modifiedOn: "2017-12-20T11:04:27.92",
  },
};
